/**
 * Module dependencies.
 */

import { JSX } from 'react';
import { Label, ProductWrapper, Thumb } from './other-category-models.style';
import { Link } from 'components/atoms/link/link';

/**
 * `Props` type.
 */

type Props = {
  onClick: () => void;
  product: any;
};

/**
 * Export `ProductItem` component.
 */

export function ProductItem({ onClick, product }: Props): JSX.Element {
  return (
    <Link ghost href={product.link ?? '#'} onClick={onClick}>
      <ProductWrapper>
        <Thumb image={product.thumb} />

        <Label>{product.name}</Label>
      </ProductWrapper>
    </Link>
  );
}
